import { Component, OnInit } from '@angular/core';

import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { map, Observable } from 'rxjs';

import { OfferGroup } from '../../../shared/data/models/collections/offer-group';
import { CollectionsService } from '../../../shared/data/services/collections.service';
import { Request } from '../../../shared/data/services/request-enum';

@Component({
  selector: 'placeme-home-offer-groups',
  templateUrl: './home-offer-groups.component.html',
  styleUrls: ['./home-offer-groups.component.scss'],
})
export class HomeOfferGroupsComponent implements OnInit {
  offerGroups$: Observable<OfferGroup[]>;

  constructor(
    private collectionsService: CollectionsService,
    private localizeRouterService: LocalizeRouterService
  ) {}

  ngOnInit(): void {
    this.offerGroups$ = this.collectionsService
      .query<{ offerGroups: OfferGroup[] }>(Request.OFFER_GROUPS, {
        locale: this.localizeRouterService.parser.currentLang,
      })
      .pipe(map(data => data.offerGroups));
  }
}
